/**
 * TOF-1570. Note: the ML team is working on new price recommendations that will replace the current implementation.
 * The endpoint will have price caps included. Given that we will only be using the existing endpoint for so much longer
 * and that BE is constrained on bandwidth, we’ve opted to add this logic on the FE as opposed to updating the endpoint
 * logic on the BE. When we switch over to the ML model, we should remove this logic.
 */
const priceLimits = {
    USD: 50000,
    EUR: 47500,
    GBP: 41000,
};

export const isPriceAboveLimit = ({
    price,
    median,
    currency,
}: {
    price: number;
    median?: number;
    currency: string;
}): boolean => {
    const limit = priceLimits[currency as keyof typeof priceLimits];

    if (limit && price >= limit) {
        return true;
    }

    if (median && price >= median * 3) {
        return true;
    }

    return false;
};
